import {useParams} from 'react-router-dom';
import TableauViz from '../../components/TableauViz';
import {useClientConfig} from '../../hooks/useClientConfig';

const ReportingPage = () => {
    const {reportId} = useParams();
    const config = useClientConfig();
    const report = config?.tableau?.reports?.find(r => r.id === reportId);

    return <TableauViz reportId={reportId} title={report?.label}/>;
};

export default ReportingPage;